export default {
    getLocale() {
        return navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language || 'en-US';
    },
    getDateTime(timestamp) {
        const date = new Date(timestamp * 1000);

        return new Intl.DateTimeFormat(this.getLocale(), {
            dateStyle: 'short',
            timeStyle: 'short'
        }).format(date);
    },
    getDateTimePrecise(timestamp) {
        const date = new Date(timestamp * 1000);

        return new Intl.DateTimeFormat(this.getLocale(), {
            dateStyle: 'short',
            timeStyle: 'medium'
        }).format(date);
    },
    getDate(timestamp) {
        const date = new Date(timestamp * 1000);

        return new Intl.DateTimeFormat(this.getLocale(), {
            dateStyle: 'short'
        }).format(date);
    },
    getDateFromInput(timestamp, format = 'full_en-GB') {
        const [style, locale] = format.split('_');

        // Some aired dates only have year or year+month precision, stored with
        // "00" placeholders (e.g. "2018-03-00", "2018-00-00"). Native Date parsing
        // of such partial strings is unreliable across browsers (Chromium throws a
        // RangeError when formatting the resulting Invalid Date), so degrade
        // gracefully instead of crashing.
        const parsed = this.parsePartialDate(timestamp);
        if (parsed && !parsed.month) return String(parsed.year);
        if (parsed && !parsed.day) return this.getMonthYearFromInput(timestamp, format);

        const date = new Date(timestamp);
        return new Intl.DateTimeFormat(locale, {
            dateStyle: style,
            timeZone: 'UTC'
        }).format(date);
    },
    getMonthYearFromInput(timestamp, format = 'full_en-GB') {
        const [, locale] = format.split('_');

        const parsed = this.parsePartialDate(timestamp);
        if (parsed && !parsed.month) return String(parsed.year);

        const date = parsed ? new Date(Date.UTC(parsed.year, parsed.month - 1, 1)) : new Date(timestamp);
        return new Intl.DateTimeFormat(locale, {
            year: 'numeric',
            month: 'long',
            timeZone: 'UTC'
        }).format(date);
    },
    /**
     * Parses a "YYYY-MM-DD" date string that may use "00" as a placeholder for an
     * unknown day and/or month (year-only or year+month precision). Components
     * are read directly via regex rather than through `new Date(string)`, since
     * engines disagree on parsing such partial ISO strings.
     * Returns null for anything that isn't a "YYYY-MM-DD" string.
     */
    parsePartialDate(input) {
        const match = typeof input === 'string' ? /^(\d{4})-(\d{2})-(\d{2})$/.exec(input) : null;
        if (!match) return null;

        const [, year, month, day] = match;
        return {
            year: Number(year),
            month: month === '00' ? null : Number(month),
            day: day === '00' ? null : Number(day),
        };
    },
    formatNumber(number) {
        return new Intl.NumberFormat(this.getLocale()).format(number);
    }
}